import { observable, action, computed, makeObservable } from "mobx";
import SettingsApi from "./api/settings";
import { LS_KEYS } from "../../consts";
import callWindowFunction from "../../utils/callWindowFunction";

class FeedSettingsStore {
  constructor(rootStore, notificationUrl) {
    makeObservable(this, {
      activatedUser: observable,
      ntfIsActivated: computed,
      setActivation: action,
    });

    this.rootStore = rootStore;
    this.SettingsApi = new SettingsApi(notificationUrl);

    this.baseUrl = `//${this.rootStore.baseUrl}/webapi/`;
    this.idUrl = `//id.${this.rootStore.baseUrl}/`;
    this.apiUrl = `//api.${this.rootStore.baseUrl}`;
    this.docsUrl = `//d.${this.rootStore.baseUrl}`;
    this.chatUrl = `//chat.${this.rootStore.baseUrl}`;
    this.webPushApi = `//api.${this.rootStore.baseUrl}/webapi/pusher/v1/`;
    this.webPushFrame = `//${this.rootStore.baseUrl}/notifications/`;
    this.staticUrl = "//files.ati.su/assets/shared/ntf_feed/assets/";
    this.currentHost = this.rootStore.baseUrl;
    this.isChatPage =
      window.location && window.location.hostname.split(".")[0] === "chat";
  }

  activatedUser = null;

  get ntfIsActivated() {
    return (
      this.rootStore.profile.userId !== null &&
      this.activatedUser === this.rootStore.profile.userId
    );
  }

  activateFeedForUser = () => {
    this.SettingsApi.enableNtfFeed().then(({ status }) => {
      if (status === 200) {
        const value = this.rootStore.profile.userId;
        callWindowFunction("putValue", [LS_KEYS.IS_ACTIVE, value]);
        this.rootStore.clientStorage.callbackIsActive({ value });
        this.rootStore.feeds.getUnreadImportantNtfs();
      }
    });
  };

  setActivation = (id) => {
    this.activatedUser = id;
  };
}

export default FeedSettingsStore;
